import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {news} from "../../../models/news";
import {scrollTo} from "../../../service/ToolsService";

type NewsListProp = {
  news: news[],
  loading?: boolean,
  refresh: () => void,
}

export const NewsList = ({news, loading, refresh}: NewsListProp) => {
  const [del, setDel] = useState(undefined as undefined | news);

  const deleteNews = async (news: news) => {
    await ApiService.delete(`/news/${news.newsId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Titre</th>
          <th className="text-center w80px">Texte</th>
          <th className="text-center w80px">Photo</th>
          <th className="text-center w80px">Visible</th>
          <th className="text-center w150px">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={6} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && news.map((n: news, i: number) => (
          <tr key={i} className="align-middle">
            <td>{n.title}</td>
            <td className="text-center">{n.text && (<i className="fa-regular fa-file-lines"/>)}</td>
            <td className="text-center">{n.photo && (<i className="fa-regular fa-image"/>)}</td>
            <td className="text-center">{n.enabled && (<i className="fa-solid fa-eye"/>)}</td>
            <td className="text-center">
              {DateService
                .toLocaleString(n.updatedAt ?? n.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/news/edit/${n.newsId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(n)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteNews(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
